<template>
  <div class="card bg-light">
    <div class="card-body">
      <h6 class="card-title">Source Details</h6>

      <div class="mb-3">
        <div class="d-flex align-items-center mb-1">
          <input class="form-check-input me-2" type="checkbox" v-model="includeDate" id="batch-date-check" />
          <label class="form-label small text-muted mb-0" for="batch-date-check">Acquisition Date</label>
        </div>
        <transition mode="out-in">
          <div v-if="includeDate" class="ms-4" :class="{ 'opacity-50': !includeDate }">
            <utc-date-input v-model="acquisitionDate" class="form-control form-control-sm" :disabled="!includeDate" />
          </div>
          <div v-else class="ms-4 p-1 border border-round bg-white opacity-50 small">Dates will be unchanged</div>
        </transition>
      </div>

      <div class="mb-3">
        <div class="d-flex align-items-center mb-1">
          <input class="form-check-input me-2" type="checkbox" v-model="includePrice" id="batch-price-check" />
          <label class="form-label small text-muted mb-0" for="batch-price-check">Price Paid</label>
          <transition mode="out-in">
            <div class="ms-auto" v-if="includePrice">
              <inline-edit :current-value="localSourcePrice" @on-save="updateSourcePrice" :disabled="!includePrice">$</inline-edit>
            </div>
            <div v-else class="ms-auto opacity-50 pt-1 small">Prices will be unchanged</div>
          </transition>
        </div>

      </div>

      <div class="mb-3">
        <div class="d-flex align-items-center mb-1">
          <input class="form-check-input me-2" type="checkbox" v-model="includeLocation" id="batch-location-check" />
          <label class="form-label small text-muted mb-0" for="batch-location-check">Source Category &amp; Location</label>
        </div>
        <transition mode="out-in">
          <div v-if="includeLocation" class="ms-4" :class="{ 'opacity-50': !includeLocation }">
            <source-input v-model="sourceData" :disabled="!includeLocation" />
          </div>
          <div v-else class="ms-4 row g-3">
            <div class="col-12">
              <button disabled class="btn btn-outline-secondary w-100">Categories will be unchanged</button>
            </div>
            <div class="col-12">
              <button disabled class="btn btn-outline-secondary w-100">Locations will be unchanged</button>
            </div>
          </div>
        </transition>
      </div>

      <p class="text-muted small mb-3">
        Only checked fields will be updated for all {{ props.items?.length || 0 }} selected item{{ props.items?.length === 1 ? '' : 's' }}.
      </p>
      <div class="d-flex align-items-center">
        <button type="button" @click="emit('cancel:source')" class="btn btn-outline-secondary me-3">Cancel</button>
        <button type="button" @click="saveSource" class="btn btn-primary ms-auto" :disabled="!includeDate && !includePrice && !includeLocation">
          Save {{ props.items?.length || 0 }} items
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import UtcDateInput from '@/app/components/Utils/UtcDateInput.vue'
import InlineEdit from '@/app/components/Utils/InlineEdit.vue'
import SourceInput from '@/app/components/inventory/SourceInput.vue'

const props = defineProps(['items', 'sourceDate','sourcePrice','sourceCategoryId','sourceLocationId'])

const emit = defineEmits(['update:source', 'cancel:source'])

const includeDate = ref(true)
const includePrice = ref(true)
const includeLocation = ref(true)

const localSourcePrice = ref(props.sourcePrice || 0)
const acquisitionDate = ref(props.sourceDate || null)
const sourceData = ref({
  source_category_id: props.sourceCategoryId || null,
  source_location_id: props.sourceLocationId || null
})

watch(() => [props.sourcePrice, props.sourceDate, props.sourceCategoryId, props.sourceLocationId], ([price, date, cat, loc]) => {
  localSourcePrice.value = price || 0
  acquisitionDate.value = date || null
  sourceData.value = { source_category_id: cat || null, source_location_id: loc || null }
})

function saveSource() {
  const payload = {}
  if (includePrice.value) payload.source_price = localSourcePrice.value
  if (includeDate.value) payload.acquisition_date = acquisitionDate.value
  if (includeLocation.value) {
    payload.source_category_id = sourceData.value?.source_category_id
    payload.source_location_id = sourceData.value?.source_location_id
  }
  emit('update:source', payload)
}

function updateSourcePrice(newPrice) {
  localSourcePrice.value = parseFloat(newPrice)
}
</script>
